import { ImageCoverView, ImageScaleView } from '@play-co/timestep-core/ui';
import { ImageScaleViewOpts } from '@play-co/timestep-core/lib/ui/ImageScaleView';

export default class LockedButtonOverlay extends ImageScaleView {
  constructor(opts: Omit<ImageScaleViewOpts, 'image'>) {
    super({
      ...opts,
      image: 'assets/ui/shared/buttons/btn_disabled_overlay.png',
    });
    this.addSubview(
      new ImageCoverView({
        image: 'assets/ui/shared/icons/footer_locked.png',
        width: 50,
        height: 59,
        x: this.style.width - 55,
        y: -14,
      }),
    );
  }
}
